import React from 'react';

import { SvgIcon, SvgIconProps } from '@mui/material';

import { ReactComponent as Icon } from './ReloadIcon.svg';

/**
 * @function
 * Auto-generated file.
 */
export const ReloadIcon = React.forwardRef<SVGSVGElement, SvgIconProps>(function ReloadIcon(props, ref) {
  return (
    <SvgIcon ref={ref} viewBox="0 0 38 44" component={Icon} {...props} />
  );
});
